
import {
  defineComponent, computed, ref, onMounted,
} from 'vue';
import { useRoute } from 'vue-router';
import { ICaseFilesManage, IPhoto, ISharedLable } from '@/types/interfaces';
import {
  BOTTOM_POPUP_TYPES, MEDIA_TYPES, NAVIGATION_PAGES, PHOTO_VIEW_TYPE, SHARE_TYPES,
} from '@/types/enums';
import { useDriveStore } from '../modules/drive/store/driveStore';
import { useMainStore } from '@/store/mainStore';
import AppLoader from './UI/AppLoader.vue';
import { lowResUrlByViewTypeByUrl } from '@/helpers/lowResPhotoUrl';
import SharePopUp from './BottomPopUp/PopUpTypes/Share/SharePopUp.vue';
import MediaSettingsPopUp from './BottomPopUp/PopUpTypes/Settings/MediaSettingsPopUp.vue';
import MoveToPopUp from './BottomPopUp/PopUpTypes/MoveTo/MoveToPopUp.vue';
import AppPdfViewer from '@/components/AppPdfViewer.vue';
import AppVideoPlayer from '@/components/AppVideoPlayer.vue';
import DriveSharedBar from '@/modules/drive/components/DriveSharedBar.vue';
import { useMessagesStore } from '@/modules/messages/store/messagesStore';

export default defineComponent({
  emits: ['close'],
  components: {
    AppPdfViewer,
    // AppLabel,
    AppLoader,
    DriveSharedBar,
    SharePopUp,
    MediaSettingsPopUp,
    AppVideoPlayer,
    MoveToPopUp,
  },
  setup() {
    const driveStore = useDriveStore();
    const mainStore = useMainStore();
    const messagesStore = useMessagesStore();

    const route = useRoute();

    const loader = ref<string>('');

    const isMediaSharePopUp = ref<boolean>(false);
    const isMediaSettingsPopUp = ref<boolean>(false);
    const isMoveToPopUp = ref<boolean>(false);

    const isMy = computed(() => driveStore.fullscreenFile?.owner?.accountId === mainStore.user.accountId);
    const isNetwork = computed(() => route.meta.isNetwork);
    const navigationPage = computed(() => route.meta.navigationPage);
    const isCase = computed(
      () => navigationPage.value === NAVIGATION_PAGES.DRIVE_CASES
        || navigationPage.value === NAVIGATION_PAGES.CASE_EDIT
        || navigationPage.value === NAVIGATION_PAGES.CASE_VIEW,
    );

    const videoUrl = computed(() => process.env.VUE_APP_MEDIA_URL + driveStore.fullscreenFile!.fileUrl);
    const isPDF = computed(() => driveStore.fullscreenFile?.name.includes('.pdf'));

    function resolvePhoto(item: { name: string, photo: IPhoto, isGroup: boolean }): string {
      if (item.photo?.url) {
        return lowResUrlByViewTypeByUrl(item.photo.url, PHOTO_VIEW_TYPE.WHSML);
      }
      if (item.isGroup) {
        // eslint-disable-next-line global-require
        return require('@/assets/img/mockup/Group.svg');
      }
      // eslint-disable-next-line global-require
      return require('@/assets/img/mockup/profile.svg');
    }

    function openPopUp(type: BOTTOM_POPUP_TYPES) {
      if (isCase.value && isMediaSharePopUp.value) {
        return;
      }
      mainStore.BottomPopUpType = type;
    }

    function setSharedLabels(labels: ISharedLable[]) {
      // is declared but it is not using now. Current code will not work correctly with new app logic
      // driveStore.fullscreenFile!.sharedLabels = labels;
    }

    function setItemShared() {
      // is declared but it is not using now. Current code will not work correctly with new app logic
      // driveStore.fullscreenFile!.shared = true
    }

    function openMovePopUp() {
      isMediaSettingsPopUp.value = false;
      isMoveToPopUp.value = true;
    }

    function deleteFile() {
      const isShared = !!driveStore.fullscreenFile!.share;
      const currentConv = !!messagesStore.currentConversation;

      if (isCase.value) {
        const removeFilePayload = {
          id: driveStore.currentCase.id!,
          fileIds: [driveStore.fullscreenFile!.id],
        } as ICaseFilesManage;
        driveStore.removeFilesFromCase(removeFilePayload);
      } else if (isShared && currentConv) {
        const label: ISharedLable = {
          name: '',
          photo: {} as IPhoto,
          isGroup: messagesStore.currentConversation!.info.isGroup,
          id: messagesStore.currentConversation!.info.id,
        };

        driveStore.removeSharingInfo(driveStore.fullscreenFile!, label);
      } else {
        driveStore.deleteMedia(driveStore.fullscreenFile!.id, driveStore.fullscreenFile!.type);
      }

      driveStore.fullscreenFile = undefined;
    }

    function updateLocation(folderId: string | null) {
      driveStore.fullscreenFile!.folderId = folderId;
    }

    onMounted(async () => {
      // driveStore.fetchCurrentFile(driveStore.fullscreenFile!.id)
      //   .then(async () => {
      //     loader.value = '';
      //     driveStore.fetchWhereFileUsing(driveStore.fullscreenFile!.id, false);
      //     if (!isNetwork.value) {
      //       driveStore.fetchSharedMediaInfo(driveStore.fullscreenFile!.id, false);
      //     }
      //   }).catch(() => { loader.value = ''; });
    });

    return {
      isPDF,
      mainStore,
      isNetwork,
      isMy,
      navigationPage,
      isCase,
      loader,
      driveStore,
      isMediaSharePopUp,
      isMediaSettingsPopUp,
      isMoveToPopUp,
      videoUrl,
      resolvePhoto,
      setSharedLabels,
      setItemShared,
      openPopUp,
      openMovePopUp,
      deleteFile,
      updateLocation,
      BOTTOM_POPUP_TYPES,
      SHARE_TYPES,
      MEDIA_TYPES,
    };
  },
});
